import React from 'react';
import styled from '@emotion/styled';
import { Container } from 'basis';
import { useStoreValue } from 'store';

const TileBox = styled.div`
  padding: 0 12px 12px 24px;
  margin: 15px 0 32px 0;
  @media (max-width: ${props => props.theme.screenSize?.md}) {
    margin-top: 24px;
    margin-bottom: 56px;
  }
  border-left: 12px solid #aedaff;
`;

// const PinkTileBox = styled.div`
//   padding: 24px 24px 32px 24px;
//   margin-bottom: 20px;
//   background-color: ${props => props.theme.pinkBackgroundColor};
//   @media (max-width: ${props => props.theme.screenSize?.md}) {
//     margin-top: 24px;
//     margin-bottom: 56px;
//   }
// `;

const OfferTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: ${props => props?.theme?.colors?.indigo ?? '#0555C8'};
`;

const OfferBody = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${props => props?.theme?.colors?.indigo ?? '#0555C8'};
  line-height: 130%;
`;

export const OfferCondition = styled.div`
  font-size: 12px;
  font-weight: 300;
  line-height: 150%;
  color: ${props => props?.theme?.colors?.indigo ?? '#0555C8'};
`;

export const OfferTileContainer = styled.div`
  ${props => `
      margin-bottom: 40px;
      ${`@media (max-width: ${props.theme.screenSize.sm})`} {
        margin: 0 0 0 4px;
        & > div {
          margin-top: 0;
          margin-bottom: 30px;
        }
  `}
`;

export const OfferTile = () => {
  const [storeState] = useStoreValue();

  if (!storeState.offer || storeState.offer.status !== 'VALID') {
    return null;
  }

  return (
    <OfferTileContainer>
      <TileBox>
        <Container testId="offer-title">
          <OfferTitle>{storeState.offer.title}</OfferTitle>
        </Container>
        <Container margin="4 0" testId="offer-description">
          <OfferBody textStyle="heading4">{storeState.offer.description}</OfferBody>
        </Container>
        {storeState.offer.promoEnd && (
          <Container testId="offer-tnc">
            <OfferCondition>
              New customers only, must be approved by {storeState.offer.promoEnd}. T&Cs apply.
            </OfferCondition>
          </Container>
        )}
      </TileBox>
    </OfferTileContainer>
  );
};
